var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home fill-height transparent flex-fill px-3"},[(_vm.$vuetify.breakpoint.mdAndUp)?_c('HeaderPanel',{attrs:{"data":_vm.store.homeHeader}}):_vm._e(),(_vm.$vuetify.breakpoint.mdAndUp)?_c('HomePanel'):_vm._e(),(_vm.$vuetify.breakpoint.smAndDown)?_c('HomePanelVertical'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }